import React, { useEffect, useState } from 'react';
import NewsEventCard from '../components/NewsEventCard';
import '../styles/newsEvents.css';
import axios from 'axios';

const NewsEvents = ({ language }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchNewsEvents = async () => {
      try {
        const res = await axios.get('http://localhost:5000/api/news-events');
        setItems(res.data);
      } catch (error) {
        console.error('Failed to fetch:', error);
      }
    };
    fetchNewsEvents();
  }, []);

  return (
    <section className="py-5 bg-light" id="news-events">
      <div className="container">
 <h2 className="fw-bold text-center mb-4">
          {language === 'am' ? 'ዝግጅቶች እና ዜና' : 'Events & News'}
        </h2>
        {/* EVENTS */}
  <h4 className="mb-3">
          {language === 'am' ? 'የሚመጡ ዝግጅቶች' : 'Upcoming Events'}
        </h4>
                <div className="row g-4">
          {items
            .filter(item => item.type === 'Event')
            .map(item => (
              <div className="col-md-6 col-lg-4" key={item.id}>
                <NewsEventCard
                  {...item}
                  image={`http://localhost:5000/uploads/${item.image}`}
                />
              </div>
            ))}
        </div>

        {/* NEWS */}
  <h4 className="mt-5 mb-3">
          {language === 'am' ? 'የቅርብ ጊዜ ዜና' : 'Latest News'}
        </h4>
                <div className="row g-4">
          {items
            .filter(item => item.type === 'News')
            .map(item => (
              <div className="col-md-6 col-lg-4" key={item.id}>
                <NewsEventCard
                  {...item}
                  image={`http://localhost:5000/uploads/${item.image}`}
                />
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default NewsEvents;
